import { ClaimCreateAdapter } from '../../../adapter';

export default async function ClaimCreateUseCase(event) {

    const url = window.location.href;
    const isLocalhost = url.includes('localhost') || url.includes('hcc.dev.bpimsapps.com');
    const isUAT = url.includes('hcc.uat.bpimsapps.com');
    const isProd = url.includes('homeprotectionclaims.bpims.com');
    const [, stage, , flag] = url.split('.');

    // prepare data
    const endpoint = isLocalhost
        ? 'https://partners-api.dev.bpimsapps.com/claim/create'
        : isUAT
        ? 'https://partners-api.uat.bpimsapps.com/claim/create'
        : isProd
        ? `${flag ? 'https://partners-api' : 'https://fes'}.${flag ? `${stage}.` : ''}bpimsapps.com${
              flag ? '' : '/partners'
          }/claim/create`
        : `${flag ? 'https://partners-api' : 'https://fes'}.${flag ? `${stage}.` : ''}bpimsapps.com${
              flag ? '' : '/partners'
          }/claim/create`;

    
    // const requestUrl = 'https://partners-api.dev.bpimsapps.com/claim/create';

    const payload = {
        ...event
    };

    // handle request
    const result = await ClaimCreateAdapter(endpoint, JSON.stringify(payload));

    return result;
}
